import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Icons } from 'sarsaparilla';
import { addChange, clearChange, getRef } from '../../actions/changes';
import { TextInput, SelectInput } from './ValidationWrapper';
import { AddressProps } from '../../props/address';

import pageStyles from './StewardAssetEditPage.scss';

const propTypes = {
  value: AddressProps,
  addressType: PropTypes.string,
  onRemove: PropTypes.func,
  getRef: PropTypes.func.isRequired,
  addChange: PropTypes.func.isRequired,
  clearChange: PropTypes.func.isRequired
};

const stateOptions = [
  { label: 'Select State', value: '' },

  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'District of Columbia', value: 'DC' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },

  { label: '(CAN) Alberta', value: 'AB' },
  { label: '(CAN) British Columbia', value: 'BC' },
  { label: '(CAN) Manitoba', value: 'MB' },
  { label: '(CAN) New Brunswick', value: 'NB' },
  { label: '(CAN) Newfoundland and Labrador', value: 'NL' },
  { label: '(CAN) Northwest Territories', value: 'NT' },
  { label: '(CAN) Nova Scotia', value: 'NS' },
  { label: '(CAN) Nunavut', value: 'NU' },
  { label: '(CAN) Ontario', value: 'ON' },
  { label: '(CAN) Prince Edward Island', value: 'PE' },
  { label: '(CAN) Quebec', value: 'QC' },
  { label: '(CAN) Saskatchewan', value: 'SK' },
  { label: '(CAN) Yukon', value: 'YT' }
];

const countryOptions = [
  { label: 'Select Country', value: '' },

  { label: 'United States', value: 'USA' },
  { label: 'Canada', value: 'CAN' }
];

export class AddressEdit extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      record: this.props.value,
      ref: this.props.getRef(
        this.props.addressType,
        { id: this.props.value.id },
        0,
        ['stateCode', 'countryCode'].reduce((m, f) => Object.assign(m, { [f]: props.value[f] }), {})
      )
    };

    this.handleChange = this.handleChange.bind(this);
    this.doRemove = this.doRemove.bind(this);
    if (!props.value.stateCode) {
      this.props.addChange(this.state.ref, { stateCode: '' });
    }
    if (!props.value.countryCode) {
      this.props.addChange(this.state.ref, { countryCode: '' });
    }
  }

  handleChange(event) {
    const { dataset: { field }, value } = event.target;

    const change = { [field]: value };

    this.setState((prevState) => ({
      ...prevState,
      record: { ...prevState.record, ...change }
    }), () => this.props.addChange(this.state.ref, change));
  }

  doRemove() {
    if (this.props.value.id) {
      this.props.addChange(this.state.ref, { _delete: true });
    }
    else {
      this.props.clearChange(this.state.ref);
    }
    this.props.onRemove(this.props.value._key);
  }

  render() {
    const { record, ref } = this.state;

    return (
      <div className={pageStyles['section-box']}>
        <Button
          appearance="subtle-danger"
          onClick={this.doRemove}
          className={pageStyles['delete-button']}
          iconBeforeElement={<Icons.IconClose />} />
        <TextInput
          label="Street Address"
          field="address1"
          changeRef={ref}
          value={get(record, 'address1')}
          onChange={this.handleChange} />
        <SelectInput
          label="State"
          field="stateCode"
          changeRef={ref}
          required
          options={stateOptions}
          value={get(record, 'stateCode')}
          onChange={this.handleChange} />
        <TextInput
          label="Street Address (cont.)"
          field="address2"
          changeRef={ref}
          value={get(record, 'address2')}
          onChange={this.handleChange} />
        <TextInput
          label="Postal Code"
          field="postalCode"
          changeRef={ref}
          value={get(record, 'postalCode')}
          onChange={this.handleChange} />
        <TextInput
          label="Street Address (cont.)"
          field="address3"
          changeRef={ref}
          value={get(record, 'address3')}
          onChange={this.handleChange} />
        <SelectInput
          label="Country"
          field="countryCode"
          changeRef={ref}
          required
          options={countryOptions}
          value={get(record, 'countryCode')}
          onChange={this.handleChange} />
        <TextInput
          label="City"
          field="city"
          changeRef={ref}
          value={get(record, 'city')}
          onChange={this.handleChange} />
      </div>
    );
  }
}

AddressEdit.propTypes = propTypes;

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getRef,
  addChange,
  clearChange
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddressEdit);
